// Utility functions to convert between local "HH:mm" and UTC "HH:mm" time strings

/**
 * Converts a local time string "HH:mm" to a UTC time string "HH:mm".
 */
export function toUtc(local: string): string {
  const [h, m] = local.split(':').map(Number);
  const d = new Date();
  d.setHours(h, m, 0, 0);
  const utcH = d.getUTCHours();
  const utcM = d.getUTCMinutes();
  return `${utcH.toString().padStart(2, '0')}:${utcM.toString().padStart(2, '0')}`;
}

/**
 * Converts a UTC time string "HH:mm" to a local time string "HH:mm".
 */
export function toLocal(utc: string): string {
  const [h, m] = utc.split(':').map(Number);
  const d = new Date();
  d.setUTCHours(h, m, 0, 0);
  const localH = d.getHours();
  const localM = d.getMinutes();
  return `${localH.toString().padStart(2, '0')}:${localM.toString().padStart(2, '0')}`;
}

export const isValidTimeStr = (s?: string) => !!s && /^\d{2}:\d{2}$/.test(s);

export const isValidTimeHHMMorHHMMSS = (t: string) => /^\d{2}:\d{2}(:\d{2})?$/.test(t);
